import React from "react";

const CloseCircle = props => (
  <svg viewBox="0 0 32 32" {...props}>
    <path
      d="M16 .75C7.437.75.5 7.687.5 16.25c0 8.562 6.938 15.5 15.5 15.5 8.563 0 15.5-6.938 15.5-15.5C31.5 7.687 24.562.75 16 .75zm7.563 19.625c.312.25.312.75 0 1.062l-2.438 2.438c-.313.312-.813.312-1.063 0L16 19.75l-4.125 4.125c-.25.312-.75.312-1.063 0l-2.437-2.5c-.313-.25-.313-.75 0-1.063l4.125-4.063-4.125-4.062c-.313-.25-.313-.75 0-1.063l2.5-2.437c.25-.312.75-.312 1.063 0L16 12.75l4.063-4.063c.25-.312.75-.312 1.062 0l2.438 2.438c.312.312.312.812 0 1.062L19.5 16.25l4.063 4.125z"
      fill="currentColor"
    />
  </svg>
);

export default CloseCircle;
